import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input, Space } from 'antd';

import {
    BUTTON_ACTION_TYPE,
    ButtonFilterAction,
} from '@app/components/UI/Button';

const AgencyFilter = ({ onSearch, onChangeKeyword }) => (
    <div className="row">
        <div className="col-md-6 col-xs-8">
            <div className="form-group filter-group">
                <Space.Compact style={{ width: '100%' }}>
                    <Input
                        style={{ width: '80px', flexShrink: 0 }}
                        defaultValue="Tìm kiếm"
                        disabled
                    />
                    <Input
                        onChange={onChangeKeyword}
                        placeholder="Tìm đại lý, người đại diện, email, điện thoại..."
                        prefix={<SearchOutlined />}
                    />
                </Space.Compact>
            </div>
        </div>

        <div className="col-md-3 col-xs-4">
            <div className="form-group">
                <div className="no-margin">
                    <div className="btn-group">
                        <ButtonFilterAction
                            labelButton="Tìm kiếm"
                            buttonType={BUTTON_ACTION_TYPE.SEARCH}
                            onClick={onSearch}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default AgencyFilter;
